/* eslint-disable no-unused-vars */
import React, { useEffect, useState, Suspense, lazy } from "react";
import { useSelector } from "react-redux";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { CToast, CToastHeader, CToastBody } from "@coreui/react";
import "./scss/style.scss";
import "./scss/__responsive.scss";
import "./scss/font-awesome.css";
import IdleTimeOutHandler from "./views/pages/Global/timeOutFunction";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import moment from "moment";
import { useCustomSelector } from "../src/views/pages/Global/GlobalConst";

const lazyRetry = function (componentImport) {
  return new Promise((resolve, reject) => {
    const hasRefreshed = JSON.parse(
      localStorage.getItem("retry-lazy-refreshed") || "false",
    );

    componentImport()
      .then((component) => {
        localStorage.setItem("retry-lazy-refreshed", "false");
        resolve(component);
      })
      .catch((error) => {
        if (!hasRefreshed) {
          // not been refreshed yet
          localStorage.setItem("retry-lazy-refreshed", "true");
          return window.location.reload(); // refresh the page
        }
        reject(error);
      });
  });
};

const DefaultLayout = lazy(() =>
  lazyRetry(() => import("./layout/DefaultLayout")),
);

const Login = lazy(() => lazyRetry(() => import("./views/pages/login/Login")));

const ActivateAccount = lazy(() =>
  import("./views/pages/activate/ActivateAccount"),
);
const ResetAccountLogin = lazy(() =>
  import("./views/pages/activate/ResetAccountLogin"),
);
const Register = lazy(() => import("./views/pages/register/Register"));
const Page404 = lazy(() => import("./views/pages/page404/Page404"));
const ForgotPassword = lazy(() => import("./views/pages/login/ForgotPassword"));
const CustomerLoginPasscode = lazy(() =>
  import("../src/views/pages/vehicleOwnerDetails/CustomerLoginPasscode"),
);
const SetPasscode = lazy(() =>
  import("../src/views/pages/vehicleOwnerDetails/SetPasscode"),
);
//./views/pages/vehicleOwnerDetails/CustomerLoginPasscode")
const Page500 = lazy(() => import("./views/pages/page500/Page500"));
import AuthService from "./services/auth.service";
// import { toastIntervalSeconds } from "./global";
// import { toastNotificationIntervalSeconds } from "./global";
import Loader from "./views/pages/Global/Loader";
import { useLoading } from "./context/LoadingContext";
import UrlTracking from "./views/pages/tracking/UrlTracking";

const App = () => {
  const [active, setIsActive] = useState(true);
  const [isLogout, setLogout] = useState(false);
  const suspenceAccountData = useCustomSelector(
    (state) => state?.accountSuspensionReducer?.suspensionReason,
  );
  const suspenceAccountAssignBtn = useCustomSelector(
    (state) => state?.accountSuspensionReducer?.assignBtnClick,
  );
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const accountType = localStorage.getItem("accountType");
  let { isLoggedIn } = useSelector((state) => state.auth);
  const arr = [];
  const apiNotResponding = false;
  const { notificationState } = useLoading();

  useEffect(() => {
    if (isLoggedIn && (accountType == "ERS" || accountType == "MST")) {
      notificationState;
    }
  }, [accountType]);

  const test = async () => {
    if (!isLoggedIn) {
      let pathArray = pathname.split("/");
      if (
        pathArray.length > 1 &&
        pathArray[1] !== "login" &&
        pathArray[1] !== "activateAccountLogin" &&
        pathArray[1] !== "resetAccountLogin" &&
        pathArray[1] !== "forgotpassword" &&
        pathArray[1] !== "Tracking" &&
        pathArray[1] !== "urlTracking" &&
        pathArray[1] !== "clientPanelSetting" &&
        pathname !== `/tracking/${pathArray[2]}/${pathArray[3]}` &&
        // pathname !== "/tracking/865006043422126" &&
        pathname !== `/route_playback/${pathArray[2]}/${pathArray[3]}` &&
        pathArray[1] !== "route_playback" &&
        pathArray[1] !== "user_notifications" &&
        pathArray[1] !== "emailverification"
      ) {
        console.warn(`${isLoggedIn}`);
        // window.location.replace("/login");
        navigate("/login");
      }
    }
  };
  useEffect(() => {
    test();
  }, [isLoggedIn]);

  const clickOnLogOut = async () => {
    try {
      const response = await AuthService.postJsonData("Api/logout");
      if (response?.apiResponseCode == "1001") {
        localStorage.clear();
        window.location.reload();
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          html: response?.apiResponseMsg,
        });
      }
    } catch (error) {
      console.warn("Error refreshing token:", error);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const refreshToken = async () => {
    const lastRefresh = localStorage.getItem("refreshToken");
    const lastLoginAt = localStorage.getItem("lastLoginAt");
    const currentTime = moment();
    const specificDateTime = moment(lastRefresh);
    const difference = specificDateTime.diff(currentTime);
    const duration = moment.duration(difference);
    const minutes = duration.minutes();
    const refreshCurrentTime = moment().format("YYYY-MM-DD HH:mm:ss");

    if (
      lastLoginAt &&
      Math.abs(minutes) >= parseInt(process.env.REACT_APP_REFRESH_TOKEN_TIME)
    ) {
      try {
        const response = await AuthService.getJsonData("refreshToken");

        if (response?.ApiResponseCode == "1001") {
          localStorage.setItem("token", JSON.stringify(response.AccessToken));
          localStorage.setItem("refreshToken", refreshCurrentTime);
          localStorage.setItem("expiresAt", response.ExpiresAt);
        }
      } catch (error) {
        console.warn("Error refreshing token:", error);
      }
    }
  };
  useEffect(() => {
    if (isLogout == true) {
      clickOnLogOut();
    }
  }, [isLogout]);

  let getToken = localStorage.getItem("token");
  let defaultPage = localStorage.getItem("defaultPage");
  // let AccessToken = localStorage.getItem("AccessToken");

  useEffect(() => {
    let pathArray = pathname.split("/");
    if (getToken && (pathname === "/login" || pathname === "/")) {
      navigate(`/${defaultPage}`);
    }

    if (
      !getToken &&
      pathname !== "/clientPanelSetting" &&
      !pathname.startsWith("/urlTracking") &&
      pathname !== `/tracking/${pathArray[2]}/${pathArray[3]}` &&
      pathname !== `/route_playback/${pathArray[2]}/${pathArray[3]}`
      // pathname !== "/tracking/865006043422126"
    ) {
      navigate("/login");
    }
    // if (AccessToken && pathname == "/Tracking") {
    //   navigate(`/${defaultPage}`);
    // }
  }, []);

  return (
    <>
      <IdleTimeOutHandler
        onActive={() => {
          setIsActive(true);
        }}
        onIdle={() => {
          setIsActive(false);
        }}
        onLogout={() => {
          setLogout(true);
        }}
      />

      {/* <Suspense fallback={loading}> */}
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route
            exact
            path="/login"
            name="Login Page"
            element={
              apiNotResponding == false ? <Login /> : <Navigate to="/404" />
            }
          />

          <Route
            match
            path="/activateAccountLogin/:token"
            name="Account Activation Window"
            element={<ActivateAccount />}
          />
          <Route
            match
            path="/resetAccountLogin/:token"
            name="Account Reset Password Window"
            element={<ResetAccountLogin />}
            // element={(props) => {
            //   return <ResetAccountLogin {...props} />;
            // }}
          />
          <Route
            exact
            path="/register"
            name="Register Page"
            element={<Register />}
          />
          <Route
            exact
            path="/forgotpassword"
            name="Forgot Password"
            element={<ForgotPassword />}
            // element={(props) => {
            //   return <ForgotPassword {...props} />;
            // }}
          />
          <Route
            exact
            path="/passcode"
            name="Customer Passcode Login"
            element={<CustomerLoginPasscode />}
          />
          <Route
            exact
            path="/set_passcode"
            name="Set Customer Passcode"
            element={<SetPasscode />}
          />
          <Route
            exact
            path="/urlTracking/:token"
            name="Url Tracking"
            element={<UrlTracking />}
          />

          <Route
            exact
            path="/404"
            name="Page 404"
            element={
              isLoggedIn || apiNotResponding ? (
                <Page404 />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route path="*" name="Home" element={<DefaultLayout />} />
        </Routes>
      </Suspense>

      {(accountType == "ERS" || accountType == "MST") && isLoggedIn ? (
        <div className="toastes--bar">
          {arr.map((value, index) => {
            var msg = value.message.substring(0, 25) + "...";

            return (
              <>
                {/* {accountType} */}
                <div className="alert--bar" key={index}>
                  <div className="alert--bar-header">
                    <div className="title">{value.title}</div>
                    <div className="actions--bar">
                      <span className="timer">{value.duration}</span>
                      <span className="closer"></span>
                    </div>
                  </div>
                  <div className="alert--bar-body">
                    {value.message.length < 25 ? value.message : msg}
                  </div>
                </div>
              </>
            );
          })}
        </div>
      ) : (
        ""
      )}
      {suspenceAccountData?.length !== 0 &&
        suspenceAccountAssignBtn == false &&
        suspenceAccountData?.reason?.Valid === true && (
          <CToast autohide={false} visible={true} className="toaster-notifier">
            <CToastHeader closeButton>
              <svg
                className="rounded me-2"
                width="20"
                height="20"
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="xMidYMid slice"
                focusable="false"
                role="img"
              >
                <rect width="100%" height="100%" fill="#dc3545"></rect>
              </svg>
              <div className="fw-bold me-auto">Account suspended</div>
            </CToastHeader>
            <CToastBody>{suspenceAccountData.reason.String} </CToastBody>
          </CToast>
        )}
    </>
  );
};
export default App;
